/**
 * Calculate the progress percentage
 * @param {*} readCount
 * @param {*} comicsCount
 * @returns
 */
export const calculateProgress = (
  readCount: number | undefined,
  comicsCount: number | undefined
) => {
  return !readCount || !comicsCount
    ? 0
    : parseFloat(((readCount / comicsCount) * 100).toFixed(2));
};

/**
 * Truncate a string
 * @param {*} str
 * @param {*} num
 * @returns
 */
export const truncate = (
  str: string,
  n: number,
  useWordBoundary: string = " "
) => {
  if (str.length <= n) {
    return str;
  }
  const subString = str.substr(0, n - 1); // the original check
  return (
    (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(" "))
      : subString) + "..."
  );
};

/**
 * Get the URLs
 * @param {*} urls
 * @returns
 */
export const getReaderLink = (urls: Array<{ url: string; type: string }>) => {
  const readerUrl = urls.find((url) => url.type === "detail");

  return readerUrl ? readerUrl.url : null;
};

/**
 * Get unique comics per order number for a reading order
 */
export const uniqBy = (theArray: Array<any>) => {
  if (!Array.isArray(theArray)) {
    return theArray;
  }
  var seen: { [key: string]: boolean } = {};
  return theArray.filter((item) => {
    var k = item.order;
    return seen.hasOwnProperty(k) ? false : (seen[k] = true);
  });
};

export const uniqByStory = (theArray: Array<any>) => {
  var seen: { [key: string]: boolean } = {};
  return theArray.filter((item) => {
    var k = `${item.id}-${item?.story}`;
    return seen.hasOwnProperty(k) ? false : (seen[k] = true);
  });
};

/**
 * Calculate progress or force 100%
 * @param {*} readCount
 * @param {*} comicsCount
 * @returns
 */
export const getProgress = (
  readCount: number | undefined,
  comicsCount: number | undefined
) => {
  if (!readCount || !comicsCount) {
    return 0;
  }

  return (readCount / comicsCount) * 100 >= 100
    ? 100
    : (readCount / comicsCount) * 100;
};

/**
 * Merge two React refs
 */
export const mergeRefs = (
  ref1:
    | React.MutableRefObject<HTMLElement | null>
    | React.RefCallback<HTMLElement>,
  ref2:
    | React.MutableRefObject<HTMLElement | null>
    | React.RefCallback<HTMLElement>
) => {
  return (node: HTMLElement | null) => {
    if (typeof ref1 === "function") {
      ref1(node);
    } else if (ref1) {
      ref1.current = node;
    }

    if (typeof ref2 === "function") {
      ref2(node);
    } else if (ref2) {
      ref2.current = node;
    }
  };
};
